import rightImg from "images/aboutsection.png";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import SectionHero4 from "components/SectionHero/SectionHero";
import SiteHeader from "containers/SiteHeader";
import Logopic from "../../images/logo-small.png";
import Why from "containers/why/why";
import ReadytoDrive from "containers/PageAbout/ReadytoDrive";
import readytodrive from "images/readytodrive.png";
import { HeroSearchFormMobile } from "components/HeroSearchForm/HeroSearchFormMobile";
import { useEffect } from "react";
import { useData } from "data/data-provider";
import CarLogo from "components/CarLogo/CarLogo";
import DreamCarSection from "components/DreamYourCar/DreamYourCar";
import NearYouSection from "components/NearYouSection/NearYouSection";
import FAQ from "components/FAQ/FAQ";
import BrowseByBrands from "components/BrowseBrand/BrowseBrand";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";

function PageHome3() {

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <div className="nc-PageHome3 relative overflow-hidden">
      {/* GLASSMOPHIN */}
      {/* <BgGlassmorphism /> */}

      {/* SECTION HERO */}
      <div
        className={
          "md:bg-[url('images/hero-right.png')] bg-[url('images/hero-right-mobile.png')] justify-between flex flex-col bg-cover md:bg-center w-full h-screen"
        }
      >
        <div className=" relative px-0">
          <div className="md:pt-4">
            <div className="overflow-clip">
              <SiteHeader />
            </div>
          </div>
          <div className="lg:hidden px-4 md:px-0 mb-16 md:mb-0">
            <HeroSearchFormMobile />
          </div>
          <div className="container relative lg:pb-16 lg:pt-8 md:pt-0 sm:pt-0 px-0 md:pb-0 sm:pb-0 mt-0 md:mt-24">
            <SectionHero4 />
          </div>
        </div>
      </div>
      <div className="container py-16  space-y-16 lg:space-y-28">
        <BrowseByBrands />
      </div>
      <div className="container relative py-16">
        <SectionGridFeaturePlaces />
      </div>
      <div className="container relative py-16">
        <SectionHero
          rightImg={rightImg}
          heading="Welcome to Kings Car Rentals"
          btnText=""
          subHeading={globalJson?.about_us_para}
        />
      </div>
      <div
        style={{
          background:
            "linear-gradient(0deg, rgba(0, 0, 0, 0) -34.51%, rgba(215, 172, 29, 0.6) -6.25%, rgba(253, 227, 6, 0.375) 12.43%, rgba(253, 227, 6, 0.075) 63.42%, rgba(0, 0, 0, 0) 100%)",
        }}
      >
        <div className="container relative py-16">
          <DreamCarSection />
        </div>
      </div>
      <div
        className={
          "lg:bg-[url('images/homesection.png')] bg-[url('images/homesectionmobile.png')] justify-between flex flex-col bg-center lg:bg-contain w-full h-screen bg-no-repeat"
        }
      >
        {" "}
        <div className="flex flex-col h-full max-w-sm lg:max-w-4xl mx-auto justify-center lg:items-center">
          <div className="flex-shrink-0 flex flex-col justify-around items-start ">
            <h2 className="font-black lg:text-6xl text-2xl text-center  !leading-[114%] text-white ">
              Save Time & Money with Top Rent Car Service in Town
            </h2>

            <div className=" flex space-x-4 my-12 mx-auto">
              <ButtonPrimary
                className="!bg-white !text-black"
                onClick={() => navigate("/about")}
              >
                Know More
              </ButtonPrimary>

              <ButtonPrimary
                className="!bg-black !text-white"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                Book Your Car
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#FFFFFF0D]">
        <div className="container">
          <div className=" mt-12 rounded-3xl">
            <div className="relative py-16 ">
              <SectionClientSay uniqueClassName="PageAbout_" />
            </div>
          </div>
        </div>
      </div>
      <div className="container py-16  space-y-16 lg:space-y-28">
        <FAQ />
      </div>
    </div>
  );
}

export default PageHome3;
